export default __webpack_public_path__ + "static/media/st5.36d72f34.jpeg";